export { OnboardingWidget } from './components/onboarding-widget';
export type {
  OnboardingFeature,
  OnboardingTask,
  OnboardingWidgetProps,
} from './components/onboarding-widget';
export { useOnboardingControls } from './hooks/useOnboardingControls';
